export const SET_SOUND_ENABLED = 'SETTINGS_ACTIONS_SET_SOUND_ENABLED';
export const SET_NOTIFICATIONS_ENABLED = 'SETTINGS_ACTIONS_SET_NOTIFICATIONS_ENABLED';
